module.exports = __webpack_public_path__ + "img/koubeishenhe.1f9b9304.png";